import { Button, Col, Container, Row, Stack } from "react-bootstrap";
import { CaretDownFill, CaretUpFill } from "react-bootstrap-icons";

export default function PlaylistAutopilotSettingsCategoryHeader({ sortConfig, requestSort, minWidth = 0, onCreate }) {
    return (
        <Container fluid style={{ minWidth: minWidth }}>
            <Row className="bg-ra-dark-blue text-white fw-bold py-1 rounded-2 fs-8-xs table-header user-select-none">
                <Col xs="3" className=" align-content-center">
                    <Row>
                        <Col xs="3" onClick={() => requestSort("code")} className=" align-self-center">
                            <Stack direction="horizontal" className="justify-content-center">
                                <span className="offset-1">Code</span>
                                <span className="col-1">
                                    {sortConfig?.key === "code" && (sortConfig.direction === "descending" ? <CaretDownFill /> : <CaretUpFill />)}
                                </span>
                            </Stack>
                        </Col>
                        <Col onClick={() => requestSort("name")} className=" align-self-center">
                            <Stack direction="horizontal" className="justify-content-start">
                                <span>Name</span>
                                <span className="col-1">
                                    {sortConfig?.key === "name" && (sortConfig.direction === "descending" ? <CaretDownFill /> : <CaretUpFill />)}
                                </span>
                            </Stack>
                        </Col>
                    </Row>
                </Col>
                <Col xs="4" className=" align-content-center">
                    <Row>
                        <Col xs="4" onClick={() => requestSort("size_type")} className=" align-self-center">
                            <Stack direction="horizontal" className="justify-content-start">
                                <span>Size Type</span>
                                <span className="col-1">
                                    {sortConfig?.key === "size_type" && (sortConfig.direction === "descending" ? <CaretDownFill /> : <CaretUpFill />)}
                                </span>
                            </Stack>
                        </Col>
                        <Col xs="3" onClick={() => requestSort("target_size")} className=" align-self-center">
                            <Stack direction="horizontal" className="justify-content-center">
                                <span className="offset-1 text-center">Target Size</span>
                                <span className="col-1">
                                    {sortConfig?.key === "target_size" && (sortConfig.direction === "descending" ? <CaretDownFill /> : <CaretUpFill />)}
                                </span>
                            </Stack>
                        </Col>
                        <Col xs="5" className=" align-content-center">
                            <Row className=" border-bottom d-none d-xl-block">
                                <Col className=" text-center ">Size Flexibility</Col>
                            </Row>
                            <Row>
                                <Col xs="6" onClick={() => requestSort("flexibility_size_absolute")} className=" align-content-center">
                                    <Stack direction="horizontal" className="justify-content-center">
                                        <span>Absolute</span>
                                        <span className="col-1">
                                            {sortConfig?.key === "flexibility_size_absolute" &&
                                                (sortConfig.direction === "descending" ? <CaretDownFill /> : <CaretUpFill />)}
                                        </span>
                                    </Stack>
                                </Col>
                                <Col xs="6" onClick={() => requestSort("flexibility_size_percentage")} className=" align-content-center">
                                    <Stack direction="horizontal" className="justify-content-center">
                                        <span>Percentage</span>
                                        <span className="col-1">
                                            {sortConfig?.key === "flexibility_size_percentage" &&
                                                (sortConfig.direction === "descending" ? <CaretDownFill /> : <CaretUpFill />)}
                                        </span>
                                    </Stack>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Col>
                <Col xs="4" className=" align-content-center">
                    <Row>
                        <Col xs="4" onClick={() => requestSort("move_up_code")} className=" align-self-center">
                            <Stack direction="horizontal" className=" justify-content-start">
                                <span>Move Up</span>
                                <span className="col-1">
                                    {sortConfig?.key === "move_up_code" && (sortConfig.direction === "descending" ? <CaretDownFill /> : <CaretUpFill />)}
                                </span>
                            </Stack>
                        </Col>
                        <Col xs="4" onClick={() => requestSort("move_down_code")} className=" align-self-center">
                            <Stack direction="horizontal" className="justify-content-start">
                                <span>Move Down</span>
                                <span className="col-1">
                                    {sortConfig?.key === "move_down_code" && (sortConfig.direction === "descending" ? <CaretDownFill /> : <CaretUpFill />)}
                                </span>
                            </Stack>
                        </Col>
                        <Col xs="4" onClick={() => requestSort("move_out_code")} className=" align-self-center">
                            <Stack direction="horizontal" className="justify-content-start">
                                <span>Move Out</span>
                                <span className="col-1">
                                    {sortConfig?.key === "move_out_code" && (sortConfig.direction === "descending" ? <CaretDownFill /> : <CaretUpFill />)}
                                </span>
                            </Stack>
                        </Col>
                    </Row>
                </Col>
                <Col xs="1" className="d-flex flex-column justify-content-center align-items-center">
                    <Button
                        variant="ra-yellow"
                        size="sm"
                        title="Add New Category"
                        onClick={onCreate}
                        className=" d-flex align-items-center column-gap-1 text-nowrap ">
                        Create New
                    </Button>
                </Col>
            </Row>
        </Container>
    );
}
